// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.contact-details[data-v-4c814e5c]{\r\n\tmargin-top: 4px;\r\n\tfont-size: 0.85em;\r\n\tcolor: var(--main-gray-5);\n}\r\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
